import React from 'react';
import {IStorefrontOrderBundle} from '../../../models/Storefront';
import { DetailsList, IColumn, SelectionMode } from '@fluentui/react';
import {
    ColumnGenerator,
    CurrencyColumnGenerator,
    IconButtonColumnGenerator
} from '../../../logic/Columns/ColumnGenerator';
import StorefrontBundleModal from "../../ProductBundles/StorefrontBundleModal";
import {useCheckProductBundleIdQuery} from "../../../store/endpoints/ProductBundleEndpoints";

interface IStorefrontOrderBundlesTableProps {
    bundles: IStorefrontOrderBundle[];
}

const StorefrontOrderBundlesTable: React.FC<IStorefrontOrderBundlesTableProps> = (props) => {
    const [selectedBundle, setSelectedBundle] = React.useState<IStorefrontOrderBundle>()
    const checkBundle = useCheckProductBundleIdQuery(selectedBundle?.bundleId ?? '', {skip: !selectedBundle?.bundleId})
    const [showBundle, setShowBundle] = React.useState(false);
    const columns: IColumn[] = [
        IconButtonColumnGenerator((item: IStorefrontOrderBundle) => { setSelectedBundle(item); setShowBundle(true); }, 'view', ""),
        ColumnGenerator('Bundle', 'name', 100, undefined, (item:IStorefrontOrderBundle) => <>
            <p style={{fontWeight: 'bold'}}>{item.name}</p>
            {item.products.map((p) => <p key={p.productId}>{p.quantity}x {p.name}</p>)}
        </>),
        CurrencyColumnGenerator('Price', 'price', 100, 100),
        ColumnGenerator('Quantity', 'quantity', 100, 100),
    ]
    return (<>
            {selectedBundle?.bundleId && checkBundle?.data && checkBundle.data === true &&
            <StorefrontBundleModal
                bundleId={selectedBundle.bundleId}
                isOpen={showBundle}
                onDismiss={() => setShowBundle(false)}
            />
            }
            <DetailsList
                selectionMode={SelectionMode.none}
                items={props.bundles}
                columns={columns}
                />
            </>
    )
}

export default StorefrontOrderBundlesTable;